import * as echarts from "echarts"
import EChartsController from "../echarts_controller"
import { world, countries } from "../world_topology"

// visualMap numeric values for piecewise color mapping
const SOURCE = 1
const VICTIM = 0

export default class extends EChartsController {
  static values = {
    victimCountryCodes: { type: Array, default: [] },
    sourceCountryCode: { type: String, default: "" },
  }

  initialize() {
    echarts.registerMap("world", world)
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    const validCountryCodes = new Set(countries.map((c) => c.code))

    const identifierCountries = this.victimCountryCodesValue
      .filter((c) => validCountryCodes.has(c.country_code))
      .map((identifierCountry) => {
        const country = countries.find(
          (c) => c.code === identifierCountry.country_code,
        )

        return {
          name: country.name,
          value: VICTIM,
        }
      })

    const sourceCountryCode = this.sourceCountryCodeValue

    if (sourceCountryCode && validCountryCodes.has(sourceCountryCode)) {
      const country = countries.find((c) => c.code === sourceCountryCode)
      identifierCountries.push({ name: country.name, value: SOURCE })
    }

    this.renderChart(this.chart, identifierCountries)
  }

  renderChart(chart, identifierCountries) {
    chart.setOption({
      tooltip: {
        trigger: "item",
        formatter: ({ name }) => name,
        confine: true,
      },

      visualMap: {
        type: "piecewise",
        orient: "horizontal",
        left: "center",
        bottom: -5,
        itemGap: 16,
        itemWidth: 20,
        itemHeight: 12,
        itemSymbol: "circle",
        textStyle: {
          color: "#f3f3f3b2",
          fontSize: 12,
        },
        pieces: [
          {
            value: SOURCE,
            label: "Actor Country of Origin",
            color: "#FF6B6D80",
          },
          {
            value: VICTIM,
            label: "Targeted Countries",
            color: "#3A3F5BA6",
          },
        ],
      },

      geo: {
        map: "world",
        roam: false,
        itemStyle: {
          areaColor: "#627C8514",
          borderColor: "#3B484C",
          borderWidth: 0.5,
        },
        emphasis: {
          label: { show: false },
          itemStyle: {
            areaColor: "#889BA3",
            opacity: 0.6,
          },
        },
        select: false,
      },

      series: [
        {
          type: "map",
          map: "world",
          geoIndex: 0,
          data: identifierCountries,
          selectedMode: false,
        },
      ],
    })
  }
}
